// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/style/customerprofile.css
// module id = 1327
// module chunks = 0